export enum ERROR_CODES {
  SYSTEM_ERROR = 500,
  REGISTER_FAILED = 400,
  LOGIN_LEGACY_FAILED = 401,
  PASSWORD_IS_BREACHED = 405,
  EMAIL_TAKEN = 408,
  NO_GROUPS_FOUND = 410,
  USER_IS_DEACTIVED = 413,
}
